module.exports = __webpack_public_path__ + "img/49.9.TU.37b0c317.png";